const firebaseConfig = {
  apiKey: "AIzaSyDyJ3fm5DOQlyLVnteALRWPbrrAgm_HZNI",
  authDomain: "carbonizo.firebaseapp.com",
  projectId: "carbonizo",
  storageBucket: "carbonizo.appspot.com",
  messagingSenderId: "1018146318053",
  appId: "1:1018146318053:web:dc6d1c507e87515d4c160c",
};

export default firebaseConfig;
